<template>
  <div class="standard-content-wrapper ">
    <div class=" margin-b20 container">
      <search
        class="standard-search"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        @handleFocus="focusClassify"
      >
      </search>
    </div>
    <div class="tip-wrapper">
      <div>评价费用说明:</div>
      <div>
        1.生产企业的产品质量评价费，由现场审查费和产品检测费两部分组成。
      </div>
      <div>
        2.非生产企业，按照石化物料分类代码，每申请一个大类物资品种的产品质量评价费为27,000元。如申请多个不同大类物资品种，则需交纳相应类别个数的产品质量评价费。
      </div>
      <div
        class="down-box"
        @click="
          getOssPath(
            'standard/ProductEvaluate/c4e7a30e-cfe6-412b-96f8-484dc5a7270d/产品质量评价业务操作手册.pdf'
          )
        "
      >
        产品质量评价业务操作手册.pdf
      </div>
    </div>

    <div class="container">
      <eui-btn
        type="primary"
        class="margin-b20 margin-t10"
        v-debounce="applicationEvaluation"
        >申请评价</eui-btn
      >
      <e-table-list
        :showAllCheckBtn="showAllCheckBtn"
        row-key="id"
        ref="tableList"
        :selectionShow="selectionShow"
        :table-data="tableData"
        :table-label="tableLabel"
        :defaultSelectionArray="defaultSelectionArray"
        :cancleSingleSelection="cancleSingleSelection"
        :rightSpanMethod="handleTableSpan"
        @handleSelect="handleSelect"
      >
        <template #showIndex="slot">
          <span>{{ slot.scope.row.index }}</span>
        </template>
        <template #agencyCompanyName="slot">
          <e-tooltip
            :content="slot.scope.row.agencyCompanyName"
            :set-length="6"
          />
        </template>
        <template #evaluateMethodName="slot">
          <div
            @click="getOssPath(slot.scope.row.evaluateMethodAttachPath)"
            style="color: #2d8cf0;cursor: pointer"
          >
            {{ slot.scope.row.evaluateMethodName }}
          </div>
        </template>
        <template #productName="slot">
          <e-tooltip :content="slot.scope.row.productName" :set-length="6" />
        </template>
        <template #scopeOfApplication="slot">
          <e-tooltip
            :content="slot.scope.row.scopeOfApplication"
            :set-length="6"
          />
        </template>
        <template #amount="slot">
          <span>{{ slot.scope.row.amount | thousandsSeparator }}</span>
        </template>
        <template #viewBusinessAdvisor="slot">
          <eui-btn
            @click.native.prevent="viewBusinessAdvisor(slot.scope.row)"
            type="text"
            font-size="12px"
            >查看
          </eui-btn>
        </template>
      </e-table-list>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, prev, pager, next, jumper"
        :current-page="queryData.pageNum"
        :total="pageTotal"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
    <!--查看业务咨询人-->
    <business-advisor-dialog
      :businessAdvisorVisible="businessAdvisorVisible"
      v-if="businessAdvisorVisible"
      :evaluationId="evaluationId"
      @closeDialog="closeDialog"
    />
    <!--提示是否合并费用-->
    <cost-coverage-dialog
      :costCoverageVisible="costCoverageVisible"
      v-if="costCoverageVisible"
      @mergerExpenses="mergerExpenses"
      @closeDialog="closeDialog"
    />
    <!--易派客产品质量评价申请须知-->
    <application-guide-dialog
      :applicationGuidVisible="applicationGuidVisible"
      v-if="applicationGuidVisible"
      @closeDialog="closeDialog"
      @checkEvaluationApplyConditionAfter="checkEvaluationApplyConditionAfter"
    />
    <!--是否在线支付的弹框-->
    <whether-pay-online-dialog
      :whetherPayOnlineVisible="whetherPayOnlineVisible"
      v-if="whetherPayOnlineVisible"
      @closeDialog="closeDialog"
    />
    <!-- 只能选择一家评价机构进行相应的操作-->
    <select-only-dialog
      :selectOnlyVisible="selectOnlyVisible"
      v-if="selectOnlyVisible"
      @closeDialog="closeDialog"
    />
    <!--友好 提示 弹框 -->
    <friendly-reminder-dialog
      :friendlyReminderVisible="friendlyReminderVisible"
      :friendlyReminderContent="friendlyReminderContent"
      v-if="friendlyReminderVisible"
      @closeDialog="closeDialog"
    />
    <!--产品类目 弹框-->
    <product-category-dialog
            :categoryTreeData="categoryTreeData"
            :productCategoryVisible="productCategoryVisible"
            v-if="productCategoryVisible"
            @closeDialog="closeDialog"
            @confirmCategory="confirmCategory"
    />

  </div>
</template>

<script>
import search from '@/modules/projectA/components/common/e-search';
import eTooltip from '../../components/common/e-tooltip';
import eTableList from '../../components/common/e-table-list-merge';
import api from '@/modules/projectA/api/ESorganization/index';
import businessAdvisorDialog from './common/businessAdvisorDialog';
import costCoverageDialog from './common/costCoverageDialog';
import applicationGuideDialog from './common/applicationGuideDialog';
import whetherPayOnlineDialog from './common/whetherPayOnlineDialog';
import selectOnlyDialog from './common/selectOnlyDialog';
import friendlyReminderDialog from './common/friendlyReminderDialog';
import productCategoryDialog from './common/productCategoryDialog';
import utils from '@/modules/projectA/utils/utils';

export default {
  components: {
    search,
    eTableList,
    eTooltip,
    businessAdvisorDialog,
    costCoverageDialog,
    applicationGuideDialog,
    whetherPayOnlineDialog,
    selectOnlyDialog,
    friendlyReminderDialog,
    productCategoryDialog
  },
  data() {
    return {
      categoryTreeData:[],
      productCategoryVisible:false,
      friendlyReminderVisible: false,
      friendlyReminderContent: '',
      businessAdvisorVisible: false,
      costCoverageVisible: false,
      applicationGuidVisible: false,
      whetherPayOnlineVisible: false,
      selectOnlyVisible: false,
      selectData: [],
      selectionArray: [], //单条 选中 的 同一 evaluationId 下的 数据
      defaultSelection: [], //所有 默认选中的 数据
      defaultSelectionArray: [], //所有 默认选中的 数据 id 集合
      indexShow: true,
      selectionShow: true,
      showAllCheckBtn: false,
      agencyCompanyIdList: [],
      productIdList: [], //资料校验 入参
      evaluationIdList: [],
      productNameList: [],
      evaluationApplyItemPriceAOList: [],
      queryData: {
        evaluateMethodName: null,
        evaluationCode: null,
        classification: null,
        specialtyName: null,
        agencyCompanyName: null,
        agencyCompanyId: null,
        supplierType: '101',
        pageNum: 1,
        pageSize: 10
      },
      pageTotal: 0,
      spanArr: [],
      tableData: [],
      tableLabel: [
        { label: '序号', param: 'serialNo', align: 'center', width: '70' },
        {
          label: '评价编码',
          param: 'evaluationCode',
          align: 'center',
          width: '120'
        },
        {
          label: '产品质量评价办法',
          param: 'evaluateMethodName',
          slot: 'evaluateMethodName',
          align: 'center',
          width: '120'
        },
        { label: '专业', param: 'specialtyName', align: 'center' },
        {
          label: '评价机构',
          param: 'agencyCompanyName',
          align: 'center',
          slot: 'agencyCompanyName',
          width: '100'
        },
        { label: '覆盖范围', param: 'level', align: 'center' },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          slot: 'productName',
          width: '100'
        },
        { label: '适用范围', param: 'supplierTypeDesc', align: 'center' },
        {
          label: '限制范围',
          param: 'scopeOfApplication',
          align: 'center',
          slot: 'scopeOfApplication',
          width: '100'
        },
        {
          label: '检测费(元)',
          param: 'amount',
          align: 'center',
          slot: 'amount'
        },
        {
          label: '业务咨询人',
          param: '',
          align: 'center',
          slot: 'viewBusinessAdvisor'
        }
      ],
      filterInfo: {
        width: {
          labelWidth: 80,
          itemWidth: 200
        },
        data: {
          evaluateMethodName: null,
          evaluationCode: null,
          classification: null,
          classificationText:null,
          specialtyId: null,
          agencyCompanyName: null
        },
        fieldList: [
          { label: '评价办法', type: 'input', value: 'evaluateMethodName' },
          { label: '评价编码', type: 'input', value: 'evaluationCode' },
          {
            label: '产品类目',
            type: "dialog",
            value: 'classificationText',
            list: 'classificationList'
          },
          {
            label: '专业',
            type: 'select',
            value: 'specialtyId',
            list: 'evaluationSpecialtyList'
          },
          {
            label: '评价机构',
            type: 'select',
            value: 'agencyCompanyName',
            list: 'evaluationAssessmentAgentList'
          }
        ],
        /**配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' }
        ]
      },
      listTypeInfo: {
        evaluationSpecialtyList: [], //专业
        evaluationAssessmentAgentList: [], //获取评价机构列表
        classificationList: [] //产品类目
      },
      cancleSingleSelection: {}
    };
  },
  methods: {
    // 申请评价的 产品质量评价办法 点击
    async getOssPath(evaluateMethodAttachPath) {
      let res = await api.getOssPath({
        ossPrivateFilePath: evaluateMethodAttachPath
      });
      if (res.success) {
        window.open(res.data, '_blank');
      }
    },
    async downloadEvaluationUserManual() {
      let res = await api.downloadEvaluationUserManual();
      if (res.success) {
        if (result.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res, '产品质量评价业务操作手册', '.pdf');
        }
      }
    },
    //产品类目的 确定
    confirmCategory(data){
      this.queryData.classification = data.lbbm;
      this.filterInfo.data.classificationText = data.text;
      this.filterInfo.data.classification = data.lbbm;
      this.productCategoryVisible = false;
    },
    closeDialog() {
      //在线支付的 不卡流程
      if (this.whetherPayOnlineVisible) {
        this.pretreatmentEvaluationApply();
      }
      this.businessAdvisorVisible = false;
      this.costCoverageVisible = false;
      this.applicationGuidVisible = false;
      this.whetherPayOnlineVisible = false;
      this.selectOnlyVisible = false;
      this.friendlyReminderVisible = false;
      this.productCategoryVisible = false;
    },
    //申请评价
    applicationEvaluation() {
      if (this.selectData.length === 0) {
        this.$message.warning('您还没有选择评价编码！');
        return false;
      }
      //须知 之前 的 校验
      this.checkEvaluationApplyConditionBefore();
    },
    //确认合并费用
    mergerExpenses() {
      //合并已经选中的 数据 和 下级数据
      let mergeArrays = this.selectData.concat(this.selectionArray);
      // console.log( this.selectData,mergeArrays,'合并 之后的 数据')
      this.selectData = mergeArrays;
      this.defaultSelectionArray = mergeArrays.map(item => item.id);
      this.$nextTick(() => {
        this.$refs.tableList.handleDefaultSelection();
      });

      this.costCoverageVisible = false;
    },
    async viewBusinessAdvisor(row) {
      console.log(row, 'row');
      this.businessAdvisorVisible = true;
      this.evaluationId = row.evaluationId;
    },
    //判断是否是 一家 机构 true:是一家  false：是多家
    judgeSingleInstitution(val) {
      let row = val.row;
      let agencyCompanyIdArr = this.selectData.map(
        item => item.agencyCompanyId
      );
      let flag = agencyCompanyIdArr.includes(row.agencyCompanyId);
      return flag;
    },
    //选择
    async handleSelect(val) {
      this.cancleSingleSelection = val.row;
      //取消选中 不处理
      let judgeArr = val.rows.filter(item => item.id === val.row.id);
      if (judgeArr.length === 0) {
        this.selectData = val.rows;
        return false;
      }

      //只能选择一家评价机构进行相应的操作 否则提示
      if (this.selectData.length > 0 && !this.judgeSingleInstitution(val)) {
        this.$nextTick(() => {
          this.$refs.tableList.handleCancleSingleSelection();
        });
        this.selectOnlyVisible = true;
        return false;
      }

      this.selectData = val.rows; //所有选中的 数据
      let row = val.row; //当前操作 的 row

      console.log(this.selectData, '这就是选中的');

      //pathList判断层级关系,存的是 父级id
      this.selectionArray = this.tableData.filter(item => {
        if (item.evaluationId === row.evaluationId) {
          //有层级关系 判断 层级 关系
          if (
            item.pathList &&
            item.pathList.length > 0 &&
            item.pathList.includes(String(row.id))
          ) {
            return item;
          } else if (!item.pathList && item.level > row.level) {
            //没有层级 关系 再 判断 覆盖范围
            return item;
          }
        }
      });

      //有子集  的 弹框
      if (this.selectionArray.length > 0) {
        this.costCoverageVisible = true;
      }
    },
    handleTableSpan({ row, column, rowIndex, columnIndex }) {
      let arr = [1, 2, 3, 4, 5, 11];
      if (arr.includes(columnIndex)) {
        const _row = this.spanArr[rowIndex]; //spanArr为控制合并几行的数组eg:[4, 0, 0, 0, 4, 0, 0, 0, 2, 0]
        const _col = _row > 0 ? 1 : 0; //合并的行数大于0那就只有一列，小于0就列数为0,相当于没了
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    //产品质量评价申请-预保存处理
    async pretreatmentEvaluationApply() {
      let params = {
        agencyCompanyIdList: this.agencyCompanyIdList,
        evaluationIdList: this.evaluationIdList,
        productIdList: this.productIdList,
        productNameList: this.productNameList,
        supplierType:  this.queryData.supplierType
      };
      let res = await api.pretreatmentEvaluationApply(params);
      if (res.success) {
        this.$router.push({
          path: '/ES/ESapply/editProductEvaluation',
          query: {
            from: 'applyPage',
            applyId: res.data.applyId,
            applyStatus: 101
          }
        });
      }
    },
    //产品质量评价申请-资料校验-供应商
    async checkEvaluationApplyConditionBefore() {
      this.applicationGuidVisible = false;

      let res = await api.checkEvaluationApplyCondition({
        evaluationApplyItemPriceAOList: this.evaluationApplyItemPriceAOList
      });
      if (res.success) {
        this.applicationGuidVisible = true; //这个 确认 之后 调下面的接口
      } else {
        //提示 各种
        this.friendlyReminderContent = res.message;
        this.friendlyReminderVisible = true;
      }
    },
    //产品质量评价申请-是否开通在线支付-供应商
    async checkEvaluationApplyConditionAfter() {
      this.applicationGuidVisible = false;

      let res = await api.checkIsOpenOnlinePay();
      if (res.success && !res.data) {
        //不开通 直接提示
        this.whetherPayOnlineVisible = true;
      } else {
        this.pretreatmentEvaluationApply();
      }
    },
    async queryEvaluationWithProductPageList() {
      let res = await api.queryEvaluationWithProductPageList(this.queryData);
      if (res.success) {
        this.tableData = res.data.records || [];
        this.pageTotal = res.data.total;
        this.spanArr = [];
        this.rowspan();
      }
    },
    //专业列表
    async queryEvaluationSpecialtyList() {
      let res = await api.queryEvaluationSpecialtyList();
      if (res.success) {
        this.listTypeInfo.evaluationSpecialtyList = [
          { id: null, name: '全部' }
        ];
        res.data.forEach(item => {
          this.listTypeInfo.evaluationSpecialtyList.push({
            id: item.specialtyId,
            name: item.specialtyName
          });
        });
      }
    },
    //产品类目
    async queryWlLbDisTree() {
      let res = await api.queryWlLbDisTree();
      if (res.success) {
        this.listTypeInfo.classificationList = [{ id: null, name: '全部' }];
        this.categoryTreeData = res.data.children;
        // this.formatData(res.data.children);
      }
    },
    //递归数据处理
    formatData(params) {
      let data = params;
      data.forEach(item => {
        if (item.hasOwnProperty('children') && item.children.length !== 0) {
          // 递归调用 直到没有 children 属性那级
          this.formatData(item.children);
        } else {
          this.listTypeInfo.classificationList.push({
            id: item.lbbm,
            name: item.text
          });
        }
      });
    },
    //获取评价机构列表
    async queryEvaluationAssessmentAgentList() {
      let res = await api.queryEvaluationAssessmentAgentList();
      if (res.success) {
        this.listTypeInfo.evaluationAssessmentAgentList = [
          { id: null, name: '全部' }
        ];
        res.data.forEach(item => {
          this.listTypeInfo.evaluationAssessmentAgentList.push({
            id: item.companyId,
            name: item.companyName
          });
        });
      }
    },
    rowspan() {
      let rowIndex = 1;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          //首次遍历获取得到的数据，将第一行数据控制合并行数的数组push(1)，表示合并一行
          this.spanArr.push(1);
          this.position = 0;
          this.$set(item, 'serialNo', rowIndex);
          rowIndex++;
        } else {
          if (
            this.tableData[index].evaluationId ===
            this.tableData[index - 1].evaluationId
          ) {
            this.spanArr[this.position] += 1; //只要sDtsend(发放月份)字段相等，spanArr的第index个元素就加1表示合并一行
            this.spanArr.push(0); //被合并的行要push(0)表示没了被合并了
          } else {
            //直到某字段不等时，改变position值
            this.spanArr.push(1); //push(1)是因为行不合并也是从1行开始
            this.position = index; //等于index表示从不等的那一行序号开始从1往上加
            this.$set(item, 'serialNo', rowIndex);
            rowIndex++;
          }
        }
      });
      console.log(this.spanArr);
    },

    focusClassify(val){
      this.productCategoryVisible = true;

      console.log(val,'val')
    },
    handleFilter(val) {
      this.queryData.evaluateMethodName = val.evaluateMethodName;
      this.queryData.evaluationCode = val.evaluationCode;
      this.queryData.classification = val.classification;
      this.queryData.specialtyName = val.specialtyName;
      this.queryData.agencyCompanyId = val.agencyCompanyName;
      this.queryData.specialtyId = val.specialtyId;
      this.queryData.pageNum = 1;
      this.queryEvaluationWithProductPageList();
    },
    handleReset() {
      this.filterInfo.data.classificationText = null;
      this.queryData = {
        evaluateMethodName: null,
        evaluationCode: null,
        classification: null,
        classificationText: null,
        specialtyName: null,
        agencyCompanyName: null,
        agencyCompanyId: null,
        supplierType: this.$route.query.supplierType
          ? this.$route.query.supplierType
          : '101',
        pageNum: 1,
        pageSize: 10
      };
      this.queryEvaluationWithProductPageList();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryEvaluationWithProductPageList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryEvaluationWithProductPageList();
    }
  },
  mounted() {
    this.queryData.supplierType = this.$route.query.supplierType
      ? this.$route.query.supplierType
      : '101';
    if (this.queryData.supplierType === '103') {
      this.tableLabel[this.tableLabel.length - 2].label = '评价费用';
    }
    this.queryEvaluationWithProductPageList();
    this.queryEvaluationSpecialtyList(); //专业列表
    this.queryWlLbDisTree(); //产品类目
    this.queryEvaluationAssessmentAgentList(); //获取评价机构列表
  },
  watch: {
    selectData(val) {
      if (val.length > 0) {
        this.agencyCompanyIdList = this.selectData.map(
          item => item.agencyCompanyId
        );
        this.evaluationIdList = this.selectData.map(item => item.evaluationId);
        this.productIdList = this.selectData.map(item => item.id);
        this.productNameList = this.selectData.map(item => item.productName);
        this.evaluationApplyItemPriceAOList = this.selectData.map(
          ({ evaluationCode, productName }) => ({
            evaluationCode: evaluationCode,
            productName: productName
          })
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
.standard-content-wrapper {
  .standard-content {
    .standard-search {
      padding: 10px 0;
      height: 150px;
      margin-top: 20px;
      border: 1px solid #d9d9d9;
    }
  }

  .tip-wrapper {
    padding: 15px 10px;
    background-color: #e8efff;
    font-size: 14px;
    font-style: normal;
    font-weight: 350;
    margin-top: 20px;
    color: #333;
    margin-bottom: 20px;

    div {
      margin: 2px 0;
    }

    .down-box {
      display: inline-block;
      color: #0064c8;
      cursor: pointer;
    }
  }
}
</style>
